import { Component, inject } from '@angular/core';
import { select, Store } from '@ngxs/store';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { ProductRemoveConfirmAction } from '@sales/states/customer-product/customer-product.actions';
import { ProductClassifications } from '@core/enums/product-classifications';
import { AccessoryProductRemoveConfirmAction } from '@sales/states/accessory-product/accessory-product.actions';
import { MbbProductRemoveConfirmAction } from '@sales/modules/mbb/states/customer-product-mbb.actions';
import { RemoveMobileProductAction } from '@sales/states/customer-product-mobilephone/customer-product-mobilephone.actions';
import { CustomerServiceProductRemoveAction } from '@sales/states/customer-service-product/customer-service-product.actions';
import { IceButtonComponent } from '../atoms/ice-button/ice-button.component';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { SetCustomerToInitialStateAction } from '@app/sales/modules/details/states/customer.actions';
import { NotificationService } from '@app/core/services/notification.service';
import { PaymentSelectors } from '@app/sales/states/payment/payment.selectors';
import { SetOrderPaymentTypeAction } from '@app/sales/states/order/order.actions';
import { UpfrontPaymentMethod } from '@app/shared/enums/payment-type';

@Component({
  selector: 'app-remove-product-dialog',
  templateUrl: './remove-product-dialog.component.html',
  styleUrls: ['./remove-product-dialog.component.scss'],
  imports: [CdkScrollable, MatDialogContent, MatDialogActions, IceButtonComponent, MatDialogClose],
})
export class RemoveProductDialogComponent {
  private store = inject(Store);
  private notificationService = inject(NotificationService);
  dialogRef = inject<MatDialogRef<RemoveProductDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA, { optional: true });

  ProductClassifications = ProductClassifications;

  productsWithUpfrontPaymentCount = select(PaymentSelectors.productsWithUpfrontPayment);

  constructor() {
    const data = this.data;

    if (data?.productClassifications !== ProductClassifications.Owner && !data?.product) {
      this.notificationService.error('Kan ikke fjerne produktet');
      this.dialogRef.close();
    }
  }

  get product() {
    return this.data;
  }

  confirmRemoveProduct() {
    switch (this.data.productClassifications) {
      case ProductClassifications.MBBProduct:
        this.store.dispatch(new MbbProductRemoveConfirmAction(this.data.product.id));
        break;
      case ProductClassifications.VoiceProduct:
        this.store.dispatch(new ProductRemoveConfirmAction(this.data.product.id));
        break;
      case ProductClassifications.Equipment:
        this.store.dispatch(new AccessoryProductRemoveConfirmAction(this.data.product.id));
        break;
      case ProductClassifications.Mobile:
        this.store.dispatch(new RemoveMobileProductAction(this.data.product.id));
        break;
      case ProductClassifications.CustomerServiceProduct:
        this.store.dispatch(new CustomerServiceProductRemoveAction(this.data.product.id));
        break;
      case ProductClassifications.Owner:
        this.store.dispatch(new SetCustomerToInitialStateAction());
        break;
      default:
        break;
    }

    if (this.productsWithUpfrontPaymentCount().amount < 1) {
      this.store.dispatch(new SetOrderPaymentTypeAction(UpfrontPaymentMethod.NoUpfrontPayment));
    }

    this.dialogRef.close();
  }
}
